import { format, addDays, isValid } from "date-fns";

export function detectChartGranularity(data) {
    if (!data || data.length < 2) return "day";
    const toMs = (d) => (d.datetime ? new Date(d.datetime).getTime() : d.timestamp * 1000);
    const gapDays = (toMs(data[1]) - toMs(data[0])) / 86_400_000;
    if (gapDays >= 25) return "month";
    if (gapDays >= 6) return "week";
    return "day";
}

export function formatChartTooltipDate(datetime, granularity = "day") {
    const date = new Date(datetime);
    if (!isValid(date)) return "";
    if (granularity === "month") return format(date, "MMM yyyy");
    if (granularity === "week") {
        const end = addDays(date, 6);
        return `${format(date, "d MMM")} – ${format(end, "d MMM")}`;
    }
    return format(date, "EEE d MMM");
}

export function formatChartAxisDate(datetime, granularity) {
    const date = new Date(datetime);
    if (!isValid(date)) return "";
    if (granularity === "month") return format(date, "MMM");
    return format(date, "d MMM");
}
